import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from 'react-intl';
// Actions
import { toggleDriversFilters } from "Redux/actions";

// Components
import SidePanel, { SidePanelBody, SidePanelHeader } from 'Components/SidePanel';
import { Grid } from "@mui/material";

import { Button } from 'Components/uiControls';

import TagsManage from 'Modules/.common/components/TagsManage';
import Pill from 'Components/Pill';
import { ToggleSwitch } from "Components";
import './styles.scss';
import _ from "lodash";
import Preferences from "Core/containers/Preferences";

const DriversAdvanceFilters = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const preferencesRef = useRef();
    const { callback } = props;
    const openFilters = useSelector(state => state.driverTableSliceRedux.openFilters);
    const loading = useSelector(state => state.driverTableSliceRedux.loading);
    const filters = useSelector(state => state.driverTableSliceRedux.filters);
    const [hasFilters, setHasFilters] = useState(false)

    const [newFilters, setNewFilters] = useState({ openSearch: "", tagIds: [], unitIds: [], units: [], tags: [], entity: 'All', includeInactiveDrivers: true, unassigned: true });
    const [loadingPills, setLoadingPills] = useState(false)

    const driverFilterOptions = [
        { id: 'All', name: messages['settingsDriver_all'] },
        { id: 'Tag', name: messages['settingsDriver_tags'] },
        { id: 'Unit', name: messages['settingsDriver_units'] },
        { id: 'Unassigned', name: messages['untagged'] },
    ];

    const entities = useMemo(
        () => [
            { id: "Unit", label: messages["unit"] },
        ],
        [messages]
    );

    useEffect(() => {
        setLoadingPills(loading)
    }, [loading]);

    const resetFilters = useCallback(() => {
        changePreferences({ ...newFilters, openSearch: "", tagIds: [], tags: [], units: [], unitIds: [], entity: 'All', includeInactiveDrivers: true, unassigned: true, offset: 0 });
        setNewFilters({ ...newFilters, openSearch: "", tagIds: [], tags: [], units: [], unitIds: [], entity: 'All', includeInactiveDrivers: true, unassigned: true, offset: 0 });
        if (callback) callback({ ...filters, openSearch: "", tagIds: [], tags: [], units: [], unitIds: [], entity: 'All', includeInactiveDrivers: true, unassigned: true, offset: 0 });
    }, [newFilters, callback, filters]);

    const changePreferences = useCallback((newValues) => {
        const oldPreferences = preferencesRef?.current?.getPreferences("User", "manageDriversView") || {}
        if (!_.isEqual(newValues, oldPreferences)) {
            const currentPreferences = { ...oldPreferences, ...newValues }
            newValues['openSearch'] = '';
            preferencesRef.current.savePreference("User", "manageDriversView", currentPreferences)
        }
    }, [preferencesRef]);

    const onOptionChangeStatus = (status) => {
        if (status) {
            changePreferences({ ...newFilters, includeInactiveDrivers: status, unassigned: status, offset: 0 });
            setNewFilters({ ...newFilters, includeInactiveDrivers: status, unassigned: status, offset: 0 });
            if (callback) callback({ ...filters, includeInactiveDrivers: status, unassigned: status, offset: 0 });
        } else {
            changePreferences({ ...newFilters, includeInactiveDrivers: status });
            setNewFilters({ ...newFilters, includeInactiveDrivers: status });
            if (callback) callback({ ...filters, includeInactiveDrivers: status });
        }
    }

    const onOptionChangeUnassigned = (status) => {
        changePreferences({ ...newFilters, unassigned: status, offset: 0 });
        setNewFilters({ ...newFilters, unassigned: status, offset: 0 });
        if (callback) callback({ ...filters, unassigned: status, offset: 0 });
    }

    const onPillChangeFilter = (filter) => {
        let tagIds = [];
        let unitIds = [];

        if (filter.tagIds && filter.tagIds.length > 0) {
            tagIds = filter?.tagIds?.map(t => {
                return t?.id
            });
            changePreferences({ ...newFilters, tags: filter?.tagIds, tagIds, offset: 0 });
            setNewFilters({ ...newFilters, tags: filter?.tagIds, tagIds, offset: 0 });
            if (callback) callback({ ...filters, tags: filter?.tagIds, tagIds, offset: 0 });
        } else if (filter.unitIds && filter.unitIds.length > 0) {
            //unitIds = filter?.unitIds;
            unitIds = filter?.unitIds?.map(t => {
                return t?.id?.toString()
            }) || [];

            changePreferences({ ...newFilters, units: filter?.unitIds, unitIds, offset: 0 });
            setNewFilters({ ...newFilters, units: filter?.unitIds, unitIds, offset: 0 });
            if (callback) callback({ ...filters, units: filter?.unitIds, unitIds, offset: 0 });
        } else {
            changePreferences({ ...newFilters, tags: [], tagIds: [], units: [], unitIds: [], offset: 0 });
            setNewFilters({ ...newFilters, tags: [], tagIds: [], units: [], unitIds: [], offset: 0 });
            if (callback) callback({ ...filters, tags: [], tagIds: [], units: [], unitIds: [], offset: 0 });
        }
    }

    return (
        <Preferences
            ref={preferencesRef}
            preferencesKey="manageDriversView"
            onInitialPreferences={(preferences) => {
                if (preferences?.includeInactiveDrivers !== undefined || preferences?.unassigned !== undefined) {
                    setNewFilters(preferences);
                    if (callback) callback(preferences);
                }
                if ((!preferences.includeInactiveDrivers) || (!preferences.unassigned) || (preferences.tags && preferences.tags.length > 0 && preferences.entity !== 'All') || (preferences.unitIds && preferences.unitIds.length > 0) || (preferences.tagIds && preferences.tagIds.length > 0)) {
                    setHasFilters(true);
                } else {
                    setHasFilters(false);
                }
            }}
        >
            <SidePanel
                isOpen={openFilters}
                toggle={() => dispatch(toggleDriversFilters(!openFilters))}
                style={{ zIndex: 2, width: '350px', transform: 'translateX(350px)' }}
                classSidePanel={hasFilters ? 'side-panel-icon-filter' : 'side-panel-icon'}
                contentStyle={{ overflowY: "hidden" }}
            >
                <SidePanelHeader>
                    <Grid container direction="row" justifyContent="space-between" alignItems="center">
                        <Grid item>
                            <h2 style={{ margin: 0 }}>
                                {messages['settingsDriver_filterBy']}
                            </h2>
                        </Grid>
                        <Grid item className="text-right">
                            <Button
                                type="icon"
                                icon="delete"
                                tooltip={messages['settingsDriver_clearFilters']}
                                placement="left"
                                onClick={resetFilters}
                            />
                        </Grid>
                    </Grid>
                </SidePanelHeader>

                <SidePanelBody>
                    <Grid
                        container
                        display={'block'}
                        marginBottom={'20px'}
                    >
                        <div className="box-toggle">
                            <ToggleSwitch
                                id="entity-tag-picker-toggle-filter-manage"
                                medium
                                blueToggle
                                optionLabels={[messages['yes'], messages['no']]}
                                checked={newFilters?.includeInactiveDrivers}
                                onChange={onOptionChangeStatus}
                                disabled={loadingPills}
                            />
                            <span className={"entity-tag-picker-span-right-manage"}>{messages['includeInactiveDrivers']}</span>
                        </div>
                    </Grid>
                    <Grid
                        container
                        display={'block'}
                        marginBottom={'20px'}
                    >
                        <div className="box-toggle">
                            <ToggleSwitch
                                id="entity-tag-picker-toggle-filter-umanage"
                                medium
                                blueToggle
                                optionLabels={[messages['yes'], messages['no']]}
                                checked={newFilters?.unassigned}
                                onChange={onOptionChangeUnassigned}
                                disabled={loadingPills}
                            />
                            <span className={"entity-tag-picker-span-right-manage"}>{messages['includeUnassignedDrivers']}</span>
                        </div>
                    </Grid>
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                    >
                        {
                            (driverFilterOptions || []).map((option, index) => {
                                return (
                                    <Grid item key={option?.id || index}>
                                        <Pill
                                            textField={'name'}
                                            item={option}
                                            outlined={option?.id === newFilters?.entity ? false : true}
                                            onClick={() => {
                                                if (option?.id === "Unassigned") {
                                                    changePreferences({ ...newFilters, entity: option?.id, tagIds: [-1], tags: [-1], units: [], unitIds: [] });
                                                    setNewFilters({
                                                        ...newFilters,
                                                        entity: option?.id,
                                                        tagIds: [-1],
                                                        unitIds: [],
                                                        tags: [-1],
                                                        units: []
                                                    });
                                                    if (callback) callback({ ...filters, entity: option?.id, tagIds: [-1], tags: [-1], units: [], unitIds: [] });
                                                } else {
                                                    changePreferences({ ...newFilters, entity: option?.id, tagIds: [], tags: [], units: [], unitIds: [] });
                                                    setNewFilters({ ...newFilters, entity: option?.id, tagIds: [], tags: [], units: [], unitIds: [] });
                                                    if (callback) callback({ ...filters, entity: option?.id, tagIds: [], tags: [], units: [], unitIds: [] });
                                                }
                                            }}
                                            style={{ border: '0' }}
                                            label="pill-label-text"
                                            colorField="default"
                                            colorSelection="005bf8"
                                            isDisabled={loadingPills}
                                        />
                                    </Grid>
                                )
                            })
                        }
                    </Grid>

                    {
                        newFilters?.entity === "Tag" &&
                        <div style={{ width: '100%', paddingTop: 20 }}>
                            <TagsManage
                                onlyTags={true}
                                enableSelectAll={false}
                                disableUntaggedSelection={true}
                                mode="list"
                                height={550}
                                placeholder={messages["search"]}
                                value={newFilters?.tags || []}
                                onChange={(items) => {
                                    onPillChangeFilter({ tagIds: items });
                                }}
                            />
                        </div>
                    }

                    {
                        newFilters?.entity === "Unit" &&
                        <div style={{ marginTop: 20 }}>

                            <div className="driver-advance-filters-tags-control">
                                <TagsManage
                                    enableSelectAll={false}
                                    disableUntaggedSelection={true}
                                    mode="list"
                                    height={550}
                                    placeholder={messages["search"]}
                                    value={newFilters?.units || []}
                                    onChange={(items) => {
                                        onPillChangeFilter({ unitIds: items });
                                    }}
                                    hideTagsWithoutEntities={true}
                                    onlyCheckEntities={true}
                                    entities={entities}
                                    entitySelected={{ id: "Unit", label: messages["unit"] }}
                                />
                            </div>
                        </div>
                    }
                </SidePanelBody>
            </SidePanel>

        </Preferences>
    )
};

export default DriversAdvanceFilters;
